function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qny95219ja"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 51920",
    transform: "translate(-3786 4296)",
    style: {
      fill: "#763535"
    },
    d: "M0 0h35v35H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 76503",
    transform: "translate(3786 -4296)",
    style: {
      clipPath: "url(#qny95219ja)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 118317"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 118318"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 64904",
    d: "M-3901.654 4283.6h26",
    transform: "rotate(45 -3864.45 4443.065)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 64905",
    d: "M-3901.654 4283.6h26",
    transform: "rotate(-45 -3793.011 4153.729)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelButton);
export default __webpack_public_path__ + "static/media/cancelButton.fa732a45f582478e80cee1206ff0f660.svg";
export { ForwardRef as ReactComponent };